import http from '@/utils/services/http'

export default {
  getRestricoesLote (loteId) {
    return http.get('/api/lote/' + loteId + '/lote-restricao')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findRestricaoLote (restricaoId) {
    return http.get('/api/lote-restricao/' + restricaoId)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastroRestricaoLote (idLote, idRestricao, oldId = null) {
    if (oldId !== null) {
      return this.atualizacaoRestricaoLote(idLote, idRestricao, oldId)
    }
    return http.post(`/api/lote/${idLote}/lote-restricao`, {restricao: idRestricao})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacaoRestricaoLote (idLote, idRestricao, oldId) {
    return http.patch(`/api/lote/${idLote}/lote-restricao`, {old: oldId, new: idRestricao})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteRestricaoLote (loteId, restricaoId) {
    return http.delete(`/api/lote/${loteId}/lote-restricao?restricao=${restricaoId}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/lote-restricoes.js